import * as yup from "yup";

export enum IbanInvoiceValidity {
  Always = "Діє завжди",
  Limited = "Діє обмежений час",
}

export const options = [
  IbanInvoiceValidity.Always,
  IbanInvoiceValidity.Limited,
];

export type FormValues = {
  validity?: IbanInvoiceValidity;
  days?: number;
  hours?: number;

  form?: string; // placeholder for form error
};

export const validationSchema = yup
  .object({
    form: yup.string(),
    validity: yup.string().oneOf(Object.values(IbanInvoiceValidity)),
    days: yup.number().transform((value) => (isNaN(value) ? undefined : value)),
    hours: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value)),
  })
  .test(
    "at-least-one-required",
    "Кількість днів або годин має бути більшою за нуль",
    function (values) {
      if (values.validity === IbanInvoiceValidity.Limited) {
        const days = values.days ?? 0;
        const hours = values.hours ?? 0;
        if (days <= 0 && hours <= 0) {
          return this.createError({
            path: "form",
            message: "Вкажіть кількість днів або годин, більшу за нуль",
          });
        }
      }
      return true;
    }
  );
